import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { TabPanel } from "@mui/lab";
import { Box, Button } from "@mui/material";
import { useState } from "react";
import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useTabSearchParams from "@entrilia/shared/hooks/useTabSearchParams";
import GeneralPageHeader from "../../../common/GeneralPageHeader";
import PageTabs from "../../../common/PageTabs";
import InvestorPortalImpersonateButton from "../InvestorPortalImpersonateButton";
import UserConsentsSection from "../consents/UserConsentsSection";
import GeneralInvestorPortalSettings from "../general/GeneralInvestorPortalSettings";
import InvestorDocumentsSettings from "../investor-documents/InvestorDocumentsSettings";
import InvitationEmailSection from "../invitation-email/InvitationEmailSection";
import PortalPagesSettings from "../pages/PortalPagesSettings";
import InvestorPortalStyleDialog from "../style/InvestorPortalStyleDialog";
import PortalSupportInfo from "../support/PortalSupportInfo";
import WatermarkSettingsSection from "../watermark/WatermarkSettingsSection";
import InvestorPortalSyncStatusInfo from "./InvestorPortalSyncStatusInfo";

const tabs = [
  "general",
  "pages",
  "investor_documents",
  "watermark",
  "user_consents",
  "support_info",
  "invitation_email",
] as const;

type Tab = (typeof tabs)[number];

const labels = [
  "General",
  "Pages",
  "Investor Documents",
  "Watermark",
  "User Consents",
  "Support Info",
  "Invitation Email",
];

export interface NavigationState {
  tab: Tab;
}

const tabSx = { height: "100%", m: 0, p: 0 };

const InvestorPortalSettingsPage = () => {
  usePageTitle("Portal Settings");

  const { selectedTab, onTabChange } = useTabSearchParams(tabs);

  const [isStyleDialogOpen, setIsStyleDialogOpen] = useState(false);

  return (
    <>
      <GeneralPageHeader title="Portal Settings" hideBorderLine>
        <InvestorPortalSyncStatusInfo />
        <Box sx={{ width: "0.5rem" }} />
        <InvestorPortalImpersonateButton variant="outlined" color="secondary" />
        <Button variant="contained" startIcon={<SettingsIcon />} onClick={() => setIsStyleDialogOpen(true)}>
          Configure Style
        </Button>
      </GeneralPageHeader>
      {isStyleDialogOpen && <InvestorPortalStyleDialog onClose={() => setIsStyleDialogOpen(false)} />}
      <PageTabs tabs={tabs} labels={labels} value={selectedTab} onChange={onTabChange}>
        <TabPanel value="general" sx={tabSx}>
          <GeneralInvestorPortalSettings />
        </TabPanel>
        <TabPanel value="pages" sx={tabSx}>
          <PortalPagesSettings />
        </TabPanel>
        <TabPanel value="investor_documents" sx={tabSx}>
          <InvestorDocumentsSettings />
        </TabPanel>
        <TabPanel value="watermark" sx={tabSx}>
          <WatermarkSettingsSection />
        </TabPanel>
        <TabPanel value="user_consents" sx={tabSx}>
          <UserConsentsSection />
        </TabPanel>
        <TabPanel value="support_info" sx={tabSx}>
          <PortalSupportInfo />
        </TabPanel>
        <TabPanel value="invitation_email" sx={tabSx}>
          <InvitationEmailSection />
        </TabPanel>
      </PageTabs>
    </>
  );
};

export default InvestorPortalSettingsPage;
